import './styles.scss';

import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';

import payload from '@app/payload';
import api from '@services/api';
import { clearPendingStripeCharge, getPendingStripeCharge, hasStripeReturnParams } from '@utils/stripeCheckout';
import { t } from '@i18n';

export default function Thanks() {
    const [stripeStatus, setStripeStatus] = useState(() => {
        return hasStripeReturnParams() && getPendingStripeCharge() ? 'pending' : 'idle';
    });

    useEffect(() => {
        if (!hasStripeReturnParams()) {
            return;
        }

        const chargeId = getPendingStripeCharge();

        if (!chargeId) {
            return;
        }

        let stopped = false;

        async function checkCharge() {
            try {
                const chargeResponse = await api.get(`checkout/charge?charge=${chargeId}`);
                const status = chargeResponse.data?.status;

                if (status === 'paid') {
                    clearPendingStripeCharge();
                    setStripeStatus('paid');
                    return true;
                }

                if (['failed', 'canceled', 'cancelled'].includes(status)) {
                    clearPendingStripeCharge();
                    setStripeStatus('failed');
                    return true;
                }
            } catch (error) {
                console.error(t('payment.error.notApproved'), error);
            }

            return false;
        }

        checkCharge();

        const interval = setInterval(async () => {
            const finished = await checkCharge();

            if (finished && !stopped) {
                clearInterval(interval);
            }
        }, 5000);

        return () => {
            stopped = true;
            clearInterval(interval);
        };
    }, []);

    if (stripeStatus === 'pending') {
        return (
            <div className='thanks-page mt-6 pb-8'>
                <CircularProgress color="inherit" />
                <h2>{t('thanks.confirming.title')}</h2>
                <span className='pt-2'>
                    {t('thanks.confirming.description')}
                </span>
            </div>
        )
    }

    if (stripeStatus === 'failed') {
        return (
            <div className='thanks-page mt-6 pb-8'>
                <h2>{t('thanks.failed.title')}</h2>
                <span className='pt-2'>
                    {t('thanks.failed.description')}
                </span>
                <button
                    type="button"
                    className='mt-2 call-support-thanks'
                    onClick={() => {
                        window.location.href = `/${payload.slug || ''}`;
                    }}
                >
                    {t('common.tryAgain')}
                </button>
            </div>
        )
    }

    return (
        <div className='thanks-page mt-6 pb-8'>
            <h2>{t('thanks.success.title')}</h2>
            <h3>{t('thanks.success.subtitle', { productName: payload.name })}</h3>
            <span className='pt-2'>
                {t('thanks.success.emailSent')}
            </span>

            <span className='pt-4'>
                {t('thanks.success.emailMissing')}
            </span>
            <span className='pt-1' style={{ opacity: 0.6 }}>
                {t('thanks.success.emailDelay')}
            </span>
            <span className='pt-1' style={{ opacity: 0.6 }}>
                {t('thanks.success.spamSupport')}
            </span>
            <button type="button" className='mt-2 call-support-thanks'>
                {t('thanks.success.supportButton')}
            </button>
        </div>
    )
}
